let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lx14I")).then(() => parcelRequire('1n1NS'));